(() => {
  const languageByCountry = { CN:'zh-CN', DE:'de', AT:'de', CH:'de', FR:'fr', BE:'fr', LU:'fr', ES:'es', MX:'es', IT:'it', PT:'pt-PT', BR:'pt-BR', NL:'nl', DK:'da', SE:'sv', NO:'nb', FI:'fi', JP:'ja', GR:'el', CY:'el', PL:'pl', CZ:'cs', HU:'hu', RO:'ro', BG:'bg' };
  try {
    localStorage.removeItem('perlavelle.reference.preference.v1');
    localStorage.removeItem('perlavelle.reference.ecb.v1');
  } catch {}
  class MarketSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const form = this.querySelector('form');
      const country = form.elements.country_code;
      const language = form.elements.locale_code;
      country.addEventListener('change', () => {
        const preferred = languageByCountry[country.value] || 'en';
        if (language.tagName === 'SELECT') {
          const options = Array.from(language.options);
          const option = options.find(item => item.value.toLowerCase() === preferred.toLowerCase()) || options.find(item => item.value === 'en');
          if (option) language.value = option.value;
        }
      });
      form.addEventListener('submit', event => {
        if (country.value === this.dataset.country && language.value.toLowerCase() === this.dataset.locale.toLowerCase()) {
          event.preventDefault();
          details.open = false;
          summary.focus();
        }
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { details.open = false; summary.focus(); event.stopPropagation(); }
      });
      this.outsideClick = event => { if (!this.contains(event.target)) details.open = false; };
      document.addEventListener('click', this.outsideClick);
      details.addEventListener('toggle', () => {
        const sticky = this.closest('sticky-header');
        if (sticky) sticky.preventHide = details.open;
      });
    }
    disconnectedCallback() { document.removeEventListener('click', this.outsideClick); }
  }
  if (!customElements.get('pv-market-selector')) customElements.define('pv-market-selector', MarketSelector);
})();
